import { ReactNode } from 'react';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr) auto;
  margin-bottom: 10px;
  align-items: center;
`;

export const ItemWrapper = styled.div`
  display: flex;
  color: ${({ theme }) => theme.palette.neutral.dark};
`;

export const Uom = styled.div`
  margin-left: 10px;
  font-weight: 600;
`;

export const UomLabel = styled.div`
  font-weight: 300;
`;

type IconWrapperProps = { onClick?: () => void; children?: ReactNode };

export const IconWrapper = styled.div<IconWrapperProps>`
  :hover {
    cursor: pointer;
  }
`;
